// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5oqzF","tabsBox":"styles_tabsBox__3oXfp","createButton":"styles_createButton__2Bkr3"};